import { Button, PanelLeftClose } from "@repo/ui";
import {
  NavigationControls,
  type NavigationControlsProps,
} from "./controls/task-explorer-nav-controls";
import { WindowControls, type WindowControlsProps } from "./controls/task-explorer-window-controls";
import type { TabWindowState } from "../../../task.types";

export type Props = Omit<WindowControlsProps, "isMinimized" | "isPinned"> &
  NavigationControlsProps & {
    isPanelOn: boolean;
    onToggleItemPanel: () => void;
    currentState: TabWindowState;
  };

export const TaskExplorerToolbar = ({
  currentState,
  onClose,
  onMinimize,
  onPin,
  isPanelOn,
  onToggleItemPanel,
  onMoveLeft,
  onMoveRight,
}: Props) => (
  <div className="flex items-center justify-between px-3 pt-2.5">
    <WindowControls
      isMinimized={currentState.isMinimized}
      isPinned={currentState.isPinned}
      onClose={onClose}
      onMinimize={onMinimize}
      onPin={onPin}
    />
    <div className="flex items-center gap-1">
      <Button
        icon={<PanelLeftClose className="h-4 w-4" />}
        variant={isPanelOn ? "primary" : "outline"}
        align="center"
        justify="center"
        onClick={onToggleItemPanel}
        className="rounded-full"
        title="Toggle panel to right"
      />
      <NavigationControls onMoveLeft={onMoveLeft} onMoveRight={onMoveRight} />
    </div>
  </div>
);
